import request from "../utils/request";

export default {
	__getList() {
		return request({
			url: `news/list`,
			method: "GET"
		});
	},
	__getData(id) {
		return request({
			url: `news/${id}`,
			method: "GET"
		});
	},
	__createData(data) {
		return request({
			url: `news/new`,
			method: "POST",
			data
		});
	},
	__updateData({ id, data }) {
		return request({
			url: `news/${id}`,
			method: "PUT",
			data
		});
	},
	__removeData(id) {
		return request({
			url: `news/${id}`,
			method: "DELETE"
		});
	},
	__sortList(data) {
		return request({
			url: `news/sort`,
			method: "PUT",
			data
		});
	},
}